import { TextValue } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { CellInner, TableBodyCellWrapper } from '../../../Common.dumb'

type Props = {
  value?: TextValue
}

export const TableBodyCellIoTUrl: FC<Props> = ({ value }) => {
  return (
    <TableBodyCellWrapper>
      <CellInner>
        {value?.textValue ? (
          <a href={value.textValue} target="_blank" rel="noopener noreferrer">
            {value.textValue}
          </a>
        ) : null}
      </CellInner>
    </TableBodyCellWrapper>
  )
}
